import { createSlice } from '@reduxjs/toolkit'
import {
  addContactGroupParticipant,
  bulkAddContactGroupParticipant,
  bulkDeleteContactGroupParticipant,
} from '@store/actions'

type ContactGroupParticipantState = {
  loading: boolean
  error: string | null
  successMessage: string | null
}

const initialState: ContactGroupParticipantState = {
  loading: false,
  error: null,
  successMessage: null,
}

const contactGroupParticipantSlice = createSlice({
  name: 'contact_group_participant',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addContactGroupParticipant.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addContactGroupParticipant.fulfilled, (state) => {
        state.loading = false
        state.successMessage = 'Contact group participants added successfully'
      })
      .addCase(addContactGroupParticipant.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

    builder
      .addCase(bulkAddContactGroupParticipant.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(bulkAddContactGroupParticipant.fulfilled, (state) => {
        state.loading = false
        state.successMessage = 'Contact group participant added successfully'
      })
      .addCase(bulkAddContactGroupParticipant.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

    builder
      .addCase(bulkDeleteContactGroupParticipant.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(bulkDeleteContactGroupParticipant.fulfilled, (state) => {
        state.loading = false
        state.successMessage = 'Contact group participant deleted successfully'
      })
      .addCase(bulkDeleteContactGroupParticipant.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export default contactGroupParticipantSlice.reducer
